import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserState } from 'src/app/_shared/state/user.state';
import { SubscriptionPlanService } from 'src/app/shared/service/subscription-plan.service';
import constants from 'src/constant.json';
import { environment } from 'src/environments/environment';
import { CmaState } from '../cma.state';

@Component({
  selector: 'app-cma-report-card',
  templateUrl: './cma-report-card.component.html',
  styleUrls: ['./cma-report-card.component.scss'],
})
export class CmaReportCardComponent implements OnInit {
  @Input() report: any;
  @Input() reportOutput: any;
  @Output() reportDeleted = new EventEmitter<string>();

  navigatedFrom: any;
  isInvestor: boolean = false;
  onDestroyNotifier$ = new Subject();
  userId: string;
  userRole: string;
  listingImageBaseUrl = environment.listingImageBaseUrl;

  constructor(
    private router: Router,
    private snackBar: MatSnackBar,
    private userState: UserState,
    public cmaState: CmaState,
    private cdr: ChangeDetectorRef,
    private subscriptionService: SubscriptionPlanService
  ) { }

  ngOnInit(): void {
    this.userState.userDetail$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (res) {
        if (res?.roles?.length > 0) {
          this.userRole = res.roles[0];
          this.userId = res.id;
          if (this.userRole == 'investor') {
            this.isInvestor = true;
          } else {
            this.isInvestor = false;
          }
        }
      }
    });

    this.reportOutput = this.report;
    this.cdr.detectChanges();
  }

  downloadReport() {
    this.openSnackBar('Coming Soon!!', 'snackbar-success');
  }

  deleteReport() {
    this.reportDeleted.emit(this.report._id);
  }

  viewReport() {
    const currentUrl = this.router.url;
    if (currentUrl.includes('my-property')) {
      this.navigatedFrom = 'myProperty';
    }
    let queryParams: any = {
      id: this.report._id || this.report.id,
    };
    if (this.navigatedFrom) {
      queryParams.from = this.navigatedFrom;
    }
    if (this.report.status === 'created') {
      this.router.navigate(['/cma/view'], { queryParams: queryParams });
    } else {
      this.openSnackBar(
        this.report.message ? 'Report is not generated due to ' + this.report.message : 'Report is not generated',
        'snackbar-error'
      );
    }
  }

  editReport() {
    if (!this.subscriptionService.checkFeatureValidity(constants.PLAN_BASED_FEATURES.editCma.key)) return;

    let queryParams: any = {
      id: this.report._id || this.report.id,
    };
    this.router.navigate(['/cma/edit'], { queryParams: queryParams, state: { from: 'reportCard' } });
  }

  openSnackBar(message, style) {
    if (message) {
      this.snackBar.open(message, '', {
        duration: 3000,
        panelClass: [style ? style : ''],
        verticalPosition: 'top',
      });
    }
  }
}
